import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import { type RootState } from "../../store/store";
import { hideSnackbar } from "../../store/slice/snackbarSlice";

const GlobalSnackbar: React.FC = () => {
    const dispatch = useDispatch();
    const { open, reason, message } = useSelector((state: RootState) => state.snackbar);

    useEffect(() => {
        if (!open) return;

        const handleClick = () => {
            if(reason === "suspended") {
                dispatch(hideSnackbar());
                window.location.reload();
            }
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [open, dispatch]);

    const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
        // Prevent closing with escape key or clickaway
        if (reason === "clickaway") return;
        dispatch(hideSnackbar());
    };

    // const handleClose = () => {
    //     dispatch(hideSnackbar());
    // };

    return (
        <div>
            <Snackbar
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleClose}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%', cursor: 'pointer' }}
                    onClick={() => {
                        if(reason === "suspended") {
                            dispatch(hideSnackbar());
                            window.location.reload();
                        }
                    }}
                >
                    { message }
                </Alert>
            </Snackbar>
        </div>
    );
};

export default GlobalSnackbar;